import { SettingsInput } from "@ts-types/generated";
import Base from "./base";

class Settings extends Base<SettingsInput, SettingsInput> {
  getAdditionalSettings = (url: string) => {
    return this.http(url, "get");
  };

  saveAdditionalSettings = (url: string, input: any) => {
    return this.http(url, "post", input);
  }
}

export default new Settings();
